// extracted by mini-css-extract-plugin
export default {"text":"FormSectionHeading_text__p2HwH"};